
import { compose, withState, defaultProps } from 'recompose';


export const withTruncation = compose(
	defaultProps({ // { value: '1' }
		lines: 5,
	}),
	withState('truncated', 'setTruncated', ({ open }) => !open), // { value: '1', lines: 5 }
);
// { value: '1', lines: 5, truncated: true, setTruncated: (v) => setState({ truncated: v }) }


export default {
	withTruncation,
}